export default __webpack_public_path__ + "static/media/kiosk-trans-greyscale-small-screens-highlight.980ae763.png";